"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeRule = void 0;
var validation_rule_1 = require("./validation-rule");
var property_1 = require("./property");
var model_1 = require("./model");
/**
 * A rule that validates that a property value is within a specific range
 */
var RangeRule = /** @class */ (function (_super) {
    __extends(RangeRule, _super);
    /**
     * Creates a rule that validates a property value is within a specific range
     * @param rootType The model type the rule is for
     * @param options The options for the rule
     */
    function RangeRule(rootType, options) {
        var _this = this;
        // ensure the rule name is specified
        options.name = options.name || "Range";
        options.message = function () {
            var format = options.property.format;
            var val = model_1.normalize(options.property.value(this), format);
            if (val == null) {
                return null;
            }
            var range = {};
            if (options.min && options.min instanceof Function) {
                try {
                    range.min = model_1.normalize(options.min.call(this), format);
                }
                catch (e) {
                    // Silently ignore min errors
                }
            }
            if (options.max && options.max instanceof Function) {
                try {
                    range.max = model_1.normalize(options.max.call(this), format);
                }
                catch (e) {
                    // Silently ignore max errors
                }
            }
            if ((range.min == null || val >= range.min) && (range.max == null || val <= range.max)) {
                // Value is within range
                return null;
            }
            var hasMin = range.min || range.min === 0;
            var hasMax = range.max || range.max === 0;
            if (hasMin && hasMax)
                return rootType.model.getResource("range-between").replace("{min}", property_1.Property$format(options.property, range.min) || range.min).replace("{max}", property_1.Property$format(options.property, range.max) || range.max);
            if (options.property.propertyType === Date) {
                if (hasMin)
                    return rootType.model.getResource("range-on-or-after").replace("{min}", property_1.Property$format(options.property, range.min) || range.min);
                else
                    return rootType.model.getResource("range-on-or-before").replace("{max}", property_1.Property$format(options.property, range.max) || range.max);
            }
            if (hasMin)
                return rootType.model.getResource("range-at-least").replace("{min}", property_1.Property$format(options.property, range.min) || range.min);
            else
                return rootType.model.getResource("range-at-most").replace("{max}", property_1.Property$format(options.property, range.max) || range.max);
        };
        // call the base type constructor
        _this = _super.call(this, rootType, options) || this;
        return _this;
    }
    // get the string representation of the rule
    RangeRule.prototype.toString = function () {
        return this.property.containingType.fullName + "." + this.property.name + " in range, min: , max: ";
    };
    return RangeRule;
}(validation_rule_1.ValidationRule));
exports.RangeRule = RangeRule;
